import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=22f020fe&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"
import style0 from "./invoice.vue?vue&type=style&index=0&id=22f020fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f020fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f020fe')) {
      api.createRecord('22f020fe', component.options)
    } else {
      api.reload('22f020fe', component.options)
    }
    module.hot.accept("./invoice.vue?vue&type=template&id=22f020fe&scoped=true", function () {
      api.rerender('22f020fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/invoice.vue"
export default component.exports